import { Container, FormControl, FormControlLabel, Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import { Stack } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { PRINTING_RESET, init, print, search } from "../../redux/actions/printing";
import Header from "../common/Header";

export default function Printing() {
  const { register, handleSubmit, getValues, formState: { errors } } = useForm();
  const columns = [
    { field: "serialNumber", headerName: "通し番号", width: 170, headerClassName: "headerColor", flex: 0.5 },
    { field: "grade", headerName: "年", width: 60, headerClassName: "headerColor", flex: 0.5 },
    { field: "class", headerName: "組", width: 60, headerClassName: "headerColor", flex: 0.5 },
    { field: "number", headerName: "番", width: 60, headerClassName: "headerColor", flex: 0.5 },
    { field: "name", headerName: "名前", width: 310, headerClassName: "headerColor", flex: 1 }
  ];

  const [gridData, setGridData] = useState([]);

  const dispatch = useDispatch();
  const message = useSelector(state => state.printing.message);
  const downloadLink = useSelector(state => state.printing.downloadLink);
  const printTarget = useSelector(state => state.printing.printTarget);
  const evaluationList = useSelector(state => state.printing.evaluationList);
  const evaluationTerm = useSelector(state => state.printing.evaluationTerm);
  const rows = useSelector(state => state.printing.rows);

  useEffect(
    () => {
      dispatch(init());
    },
    [dispatch]
  );

  useEffect(
    () => {
      setGridData(rows);
    },
    [rows]
  );

  useEffect(
    () => {
      if (downloadLink) {
        window.open(`/neqst${downloadLink}`, "_blank");
        dispatch({ type: PRINTING_RESET });
      }
    },
    [downloadLink]
  );

  const searchSubmit = request => {
    dispatch(
      search({
        ...request,
        printTarget: request.printTarget ? request.printTarget : ""
      })
    );
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const handleSelectionModelChange = selectionModel => {
    setSelectedRows(selectionModel);
  };

  const handlePrintButton = () => {
    const selectedData = selectedRows.map(rowId => gridData.find(row => row.id === rowId));
    const request = {
      printTarget: getValues("printTarget"),
      listId: getValues("listId"),
      termId: getValues("termId"),
      students: selectedData.map(data => {
        return {
          serialNumber: data.serialNumber,
          grade: data.grade
        };
      })
    };
    dispatch(print(request));
  };

  if (message) {
    alert(message);
    window.location.href = "/StaffMenu";
    return;
  }

  return (
    <Box>
      <Header />
      <Container>
        <Box
          sx={{
            marginTop: 4,
            marginLeft: 9,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h3" variant="h7" align="left">
            印刷
          </Typography>
        </Box>

        <Box
          sx={{
            marginTop: 1,
            marginLeft: 17,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h5" variant="h7" align="left">
            印刷条件検索
          </Typography>
        </Box>
        <Container maxWidth="lg">
          <Box
            sx={{
              m: 2,
              display: "flex",
              flexDirection: "column",
              bgcolor: "#fff9c4"
            }}
          >
            <Box
              sx={{
                mt: 1,
                alignItems: "left",
                justifyContent: "left"
              }}
            >
              <Grid container sx={{flexGrow: 1}} spacing={1} alignItems={"flex-start"} textAlign={"left"}>

                <Grid item xs={4} lg={3} mt={1}>
                  <FormControl sx={{ mr: 3, ml: 5 }}>
                    <Typography variant="h7" align="left">
                      通し番号
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={8} lg={9} mt={1}>
                  <FormControl>
                    <TextField
                      id="outlined-basic"
                      size="small"
                      variant="outlined"
                      sx={{ background: "white" }}
                      style={{ width: "300px" }}
                      {...register("serialNumber", {
                        pattern: { value: /^[0-9]+$/, message: "通し番号は数字で入力してください。" }
                      })}
                    />
                    {errors.serialNumber &&
                      <span className="error-msg">
                        {errors.serialNumber.message} <br />
                      </span>}
                  </FormControl>
                </Grid>

                <Grid item xs={4} lg={3}>
                  <FormControl sx={{ mr: 3, ml: 5 }}>
                    <Typography variant="h7" align="left">
                      学年
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={8} lg={9}>
                  <FormControl>
                    <TextField
                      id="outlined-basic"
                      size="small"
                      variant="outlined"
                      sx={{ background: "white" }}
                      style={{ width: "300px" }}
                      {...register("grade", {
                        pattern: { value: /^[0-9]+$/, message: "学年は数字で入力してください。" }
                      })}
                    />
                    {errors.grade &&
                      <span className="error-msg">
                        {errors.grade.message}
                      </span>}
                  </FormControl>
                </Grid>

                <Grid item xs={4} lg={3}>
                  <FormControl sx={{ mr: 3, ml: 5 }}>
                    <Typography variant="h7" align="left">
                      クラス
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={8} lg={9}>
                  <FormControl>
                    <TextField
                      id="outlined-basic"
                      size="small"
                      variant="outlined"
                      sx={{ background: "white" }}
                      style={{ width: "300px" }}
                      {...register("class", {
                        pattern: { value: /^[0-9]+$/, message: "クラスは数字で入力してください。" }
                      })}
                    />
                    {errors.class &&
                      <span className="error-msg">
                        {errors.class.message}
                      </span>}
                  </FormControl>
                </Grid>

                <Grid item xs={4} lg={3}>
                  <FormControl sx={{ mr: 3, ml: 5 }}>
                    <Typography variant="h7" align="left">
                      番号
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={8} lg={9}>
                  <FormControl>
                    <TextField
                      id="outlined-basic"
                      size="small"
                      variant="outlined"
                      sx={{ background: "white" }}
                      style={{ width: "300px" }}
                      {...register("number", {
                        pattern: { value: /^[0-9]+$/, message: "番号は数字で入力してください。" }
                      })}
                    />
                    {errors.number &&
                      <span className="error-msg">
                        {errors.number.message}
                      </span>}
                  </FormControl>
                </Grid>

                <Grid item xs={4} lg={3}>
                  <FormControl sx={{ mr: 3, ml: 5 }}>
                    <Typography variant="h7" align="left">
                      氏名
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={8} lg={9}>
                  <FormControl>
                    <TextField
                      id="outlined-basic"
                      size="small"
                      variant="outlined"
                      sx={{ background: "white" }}
                      style={{ width: "300px" }}
                      {...register("name")}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

            <Grid container sx={{flexGrow: 1}} spacing={1} alignItems={"flex-start"} textAlign={"left"}>
              
              <Grid item xs={4} lg={3} mt={5}>
                <FormControl sx={{ mr: 3, ml: 5, mt: 1.3 }}>
                  <Typography variant="h7" align="left">
                    印刷対象
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9} mt={5}>
                <FormControl>
                  <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                    {printTarget.map(target =>
                      <FormControlLabel
                        key={target.code}
                        value={target.code}
                        control={<Radio />}
                        {...register("printTarget")}
                        label={target.name}
                      />
                    )}
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={3}>
                <FormControl sx={{ mr: 3, ml: 5, mt: 1.3 }}>
                  <Typography variant="h7" align="left">
                    評価内容
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9}>
                <FormControl>
                  <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                    {evaluationList.map(list =>
                      <FormControlLabel
                        value={list.listId}
                        key={list.listId}
                        control={<Radio />}
                        label={list.listName}
                        {...register("listId")}
                      />
                    )}
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={3} mb={1}>
                <FormControl sx={{ mr: 3, ml: 5, mt: 1.3 }}>
                  <Typography variant="h7" align="left">
                    評価期間
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9} mb={1}>
                <FormControl>
                  <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                    {evaluationTerm.map(term =>
                      <FormControlLabel
                        value={term.termId}
                        key={term.termId}
                        control={<Radio />}
                        label={term.termName}
                        {...register("termId")}
                      />
                    )}
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth="sm">
          <Stack sx={{ mr: 7 }} direction="row" spacing={5} justifyContent="center">
            <Button variant="contained" sx={{ bgcolor: "#82b1ff", width: "50%" }} onClick={handleSubmit(searchSubmit)}>
              検索
            </Button>
          </Stack>
        </Container>
        <Box
          sx={{
            m: 2,
            mt: 5,
            display: "flex",
            flexDirection: "column"
          }}
        >
          <Box sx={{ alignItems: "center", justifyContent: "center", ml: 3 }} fullWidth>
            <div
              style={{
                height: 330,
                width: "100%",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <DataGrid
                sx={{
                  bgcolor: "white",
                  " .headerColor": {
                    backgroundColor: "#ffcc80"
                  }
                }}
                rows={gridData}
                columns={columns}
                experimentalFeatures={{ newEditingApi: true }}
                onSelectionModelChange={handleSelectionModelChange}
                checkboxSelection
              />
            </div>
          </Box>

          <Container maxWidth="sm" sx={{ mt: 5 }}>
            <Button variant="contained" sx={{ bgcolor: "#82b1ff", width: "50%" }} onClick={handlePrintButton}>
              印刷
            </Button>
          </Container>
        </Box>

        <Box sx={{ alignItems: "right", justifyContent: "right", m: 2, mr: 12, display: "flex" }}>
          <Button variant="contained" size="large" href="/StaffMenu" sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}>
            戻る
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
